export default "__VITE_ASSET__d15d255e__"